<script setup lang="ts">
import AppRawButton from '../appRawButton/AppRawButton.vue';
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';

import type { AppMapToggleContent } from './AppMapToggleButton.model';

interface AppMapToggleButtonProps {
  content: AppMapToggleContent;
}

const props = defineProps<AppMapToggleButtonProps>();
</script>

<template>
  <AppRawButton class="app-map-toggle-button" @click="props.content.action">
    <AppSvgIcon :name="props.content.icon" />
    <span class="text">
      {{ props.content.text }}
    </span>
  </AppRawButton>
</template>

<style scoped lang="scss">
@use '../../styles/fonts' as *;
@use '../../styles/media' as *;

.app-map-toggle-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: var(--spacing-12) var(--spacing-32);
  background-color: var(--color-neutral-70);
  color: var(--color-white);
  border-radius: var(--border-radius-8);
  width: fit-content;
  height: fit-content;
  height: 44px;

  @include on-hover {
    cursor: pointer;
  }

  .text {
    @include font-label-m-bold;
  }
}
</style>
